import { guardArray } from "@msuite/utils/array";
import { parseJsonb } from "@msuite/utils/object";
import type { WorkspaceLegalSchema } from "@msuite/utils/schemas";
import { View } from "@react-pdf/renderer";
import React from "react";
import { DEFAULT_PAGE_INSETS, type PageInsets } from "../_defaults";
import { useDocumentContext } from "../context";
import { tw } from "../tailwind";
import { Text } from "../text";

/** Props Interface */
interface FooterProps {
	insets?: PageInsets;
}

export function Footer({ insets }: FooterProps) {
	/** Context */
	const context = useDocumentContext();

	/** Json */
	const legal = parseJsonb<WorkspaceLegalSchema>(context.workspaceMetadata?.legal);

	/** Render */
	return (
		<React.Fragment>
			<View
				fixed
				style={{
					position: "absolute",
					bottom: 0,
					left: 0,
					paddingTop: "50px",
					paddingLeft: `${insets?.left ?? DEFAULT_PAGE_INSETS.left}px`,
					paddingRight: `${insets?.right ?? DEFAULT_PAGE_INSETS.right}px`,
					width: "100%",
					height: `${insets?.bottom ?? DEFAULT_PAGE_INSETS.bottom}px`,
				}}
			>
				<View
					wrap={false}
					style={{
						flexDirection: "row",
						gap: "50px",
						height: "100%",
						width: "100%",
					}}
				>
					{guardArray(legal?.blocks).map((block, index) => (
						<View
							key={index}
							style={tw("flex-1 gap-0.5")}
						>
							{guardArray(block).map((line, lineIndex) => (
								<Text
									key={lineIndex}
									style={tw("text-[0.65rem]")}
								>
									{line}
								</Text>
							))}
						</View>
					))}
				</View>
			</View>
		</React.Fragment>
	);
}
